import React from "react";
import { motion } from "framer-motion";

const WhatsAppButton = () => {
  const phoneNumber = "918210345655"; // include country code
  const message =
    "Hello RetailMitra! I want to take my shop digital. Can you help me set up?";

  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-[100]
                 bg-[#25D366] p-4 rounded-full shadow-2xl
                 flex items-center justify-center group"
      aria-label="Chat on WhatsApp"
    >
      {/* Tooltip */}
      <span
        className="absolute right-16 bg-white text-slate-800 text-sm font-semibold
                   py-2 px-4 rounded-xl shadow-lg border border-slate-100
                   opacity-0 group-hover:opacity-100 transition-opacity
                   whitespace-nowrap pointer-events-none"
      >
        Chat with us on WhatsApp 💬
      </span>

      {/* Pulse Effect */}
      <motion.span
        animate={{ scale: [1, 1.5, 1], opacity: [0.4, 0, 0.4] }}
        transition={{ duration: 2, repeat: Infinity }}
        className="absolute inset-0 bg-[#25D366] rounded-full -z-10"
      />

      {/* WhatsApp Official Logo */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="white"
        className="w-8 h-8"
      >
        <path d="M16.001 3C9.383 3 4 8.383 4 15c0 2.645.868 5.07 2.332 7.03L4 29l7.18-2.305A11.94 11.94 0 0 0 16 27c6.617 0 12-5.383 12-12S22.617 3 16.001 3zm0 21.818c-1.97 0-3.897-.53-5.577-1.535l-.4-.24-4.262 1.37 1.394-4.15-.26-.426A9.79 9.79 0 0 1 6.21 15c0-5.41 4.38-9.79 9.79-9.79 5.41 0 9.79 4.38 9.79 9.79 0 5.41-4.38 9.79-9.79 9.79zm5.364-7.36c-.292-.146-1.728-.852-1.995-.948-.266-.097-.46-.146-.655.146-.195.292-.752.948-.922 1.144-.17.195-.34.219-.632.073-.292-.146-1.23-.453-2.343-1.445-.866-.773-1.452-1.728-1.622-2.02-.17-.292-.018-.45.128-.596.13-.13.292-.34.438-.51.146-.17.195-.292.292-.487.097-.195.049-.365-.024-.511-.073-.146-.655-1.58-.898-2.165-.237-.57-.478-.493-.655-.502l-.56-.01c-.195 0-.511.073-.778.365-.267.292-1.02.995-1.02 2.428 0 1.433 1.044 2.82 1.19 3.015.146.195 2.055 3.138 4.978 4.4.695.3 1.237.479 1.66.613.698.222 1.334.19 1.835.116.56-.083 1.728-.706 1.97-1.385.243-.68.243-1.264.17-1.385-.073-.122-.266-.195-.56-.341z" />
      </svg>
    </motion.a>
  );
};

export default WhatsAppButton;
